<template>
<div class="col-md-12">
    <b-container class="mt-3" style="text-align:center">
        <h4 style="color:#00A2E4; font-weight:600;">UNEA Resolutions Closure</h4> 
    </b-container>
    <b-container>
        <form ref="form" @submit.prevent="saveOutcome" class="mt-4">
            <b-row>
                <b-col sm="12">
                <h5 style="color:#00A2E4; font-weight:600;">Section A: For Resolution Focal Point (s)</h5>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Outcome Code</label>
                </b-col>
                <b-col sm="9">
                    <b-form-input v-bind:disabled="savingInfo" style="background-color:#F4F4F4; border-radius: unset;" id="outcome_code" v-model="model.outcome_code" :state="outcomeCodeState" required></b-form-input>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Outcome Name</label>
                </b-col>
                <b-col sm="9">
                    <b-form-input v-bind:disabled="savingInfo" style="background-color:#F4F4F4; border-radius: unset;" id="outcome_name" v-model="model.outcome_name" :state="outcomeNameState" required></b-form-input>
                </b-col>
            </b-row>

            <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Lead Division</label>
                </b-col>
                <b-col sm="9">
                   <multiselect v-bind:disabled="savingInfo" style="background-color:#F4F4F4; border-radius: unset;" v-model="model.closure_division" id="division"
                                 :options="divisionsOptions" :multiple="true"
                                 :searchable="true"
                                 :loading="isLoadingDivisions"
                                 :internal-search="false"
                                 :clear-on-select="false"
                                 :close-on-select="false"
                                 :options-limit="300"
                                 :show-no-results="false"
                                 :hide-selected="true"
                                 :class="(model.closure_division.length == 0 ? 'emptySelect' :'')"
                                 @search-change="asyncFindDivisions"
                                 placeholder="Type to search lead Division" track-by="value" label="text">
                    </multiselect>
                </b-col>
            </b-row>

            <b-row class="my-3">
                  <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Lead Sub-programme</label>
                </b-col>
                <b-col sm="9">
                    <b-form-select v-bind:disabled="savingInfo" v-model="model.sub_programme" style="background-color:#F4F4F4; border-radius: unset;" id="pows" :options="powsOptions"
                           :state="powState" required>
                        <template v-slot:first>
                            <option value="">-- none --</option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Primary Reporter</label>
                </b-col>
                <b-col sm="9">
                    <multiselect v-bind:disabled="savingInfo" style="background-color:#F4F4F4; border-radius: unset;" v-model="model.closure_primary_reporter" id="primary_reporter"
                                 :options="primaryReporterOptions" :multiple="true"
                                 :searchable="true"
                                 :loading="isLoadingPrimaryReporter"
                                 :internal-search="false"
                                 :clear-on-select="false"
                                 :close-on-select="false"
                                 :options-limit="300"
                                 :show-no-results="false"
                                 :class="(model.closure_primary_reporter.length == 0 ? 'emptySelect' :'')"
                                 :hide-selected="true"
                                 @search-change="asyncFindPrimary"
                                 placeholder="Type to search primary reporter" track-by="value" label="text">
                    </multiselect>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Secondary Reporter</label>
                </b-col>
                <b-col sm="9">
                    <multiselect v-bind:disabled="savingInfo" style="background-color:#F4F4F4; border-radius: unset;" v-model="model.closure_secondary_reporter" id="secondary_reporter"
                                 :options="secondaryReporterOptions" :multiple="true"
                                 :searchable="true"
                                 :loading="isLoadingSecondaryReporter"
                                 :internal-search="false"
                                 :clear-on-select="false"
                                 :close-on-select="false"
                                 :options-limit="300"
                                 :show-no-results="false"
                                 :hide-selected="true"
                                 :class="(model.closure_secondary_reporter.length == 0 ? 'emptySelect' :'')"
                                 @search-change="asyncFindSecondary"
                                 placeholder="Type to search secondary reporter" track-by="value" label="text">
                    </multiselect>
                    <!--<pre class="language-json"><code>{{ model.secondary_reporter }}</code></pre>-->
                </b-col>
            </b-row>
            <b-row class="my-3">
                  <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">UNEA Assembly</label>
                </b-col>
                <b-col sm="9">
                    <b-form-select v-bind:disabled="savingInfo" v-model="model.assembly_id" style="background-color:#F4F4F4; border-radius: unset;" id="assembly_id" :options="assemblyOptions"
                           :state="assemblyIdState" required>
                        <template v-slot:first>
                            <option value="">-- none --</option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
             <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Milestone Attainment Status</label>
                </b-col>
                
                <b-col sm="9">
                    <h6><strong><em>Milestones attainment Status:</em></strong> (Select the overall attainment of the resolution’s milestones. <strong><em>‘Not Applicable’</em></strong> applies to UNEA Outcomes which did not have milestones in their implementation)</h6>
                    <b-form-select v-bind:disabled="savingInfo" style="background-color:#F4F4F4; border-radius: unset;" v-model="model.status_id" id="status_id" :options="statusOptions"
                            :state="statusIdState" required>
                        <template v-slot:first>
                            <option value="">-- none --</option>
                        </template>
                    </b-form-select>
                </b-col>
                <!-- <b-col sm="9">
                    
                    <b-form-radio-group
                    v-model="model.status_id"
                    :options="statusOptions"
                    class="mb-3"
                    value-field=""
                    text-field="name"
                    disabled-field="notEnabled"
                    ></b-form-radio-group>
                    <div class="mt-3">Selected: <strong>{{ selected }}</strong></div>
                </b-col> -->
            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Reason for Closure</label>
                </b-col>
                <b-col sm="9">
                     <h6><strong><em>‘Completed’</em></strong> means mandate/s or action/s requested in the resolution were completed or achieved. <strong><em>‘Closed for Secretariat Reporting’</em></strong> means the Secretariat has completed actions to fulfill the mandate Member States assigned through the resolution but there may be pending actions requested for other actors like Member States. <strong><em>‘Superseded’</em></strong> means UNEA adopted another resolution at a later session and any further reporting can be done under the new resolution.<strong><em> 'Integrated with POW reporting’</em></strong> means reporting on all secretariat mandates was <strong><em>fully</em></strong> integrated under performance reporting for a POW adopted <strong><em>after</em></strong> the resolution. </h6>
                    <b-form-select v-bind:disabled="savingInfo" style="background-color:#F4F4F4; border-radius: unset;" v-model="model.reason_id" id="" :options="reasonOptions"
                            :state="outcomeTypeState" required>
                        <template v-slot:first>
                            <option value="">-- none --</option>
                        </template>
                    </b-form-select>
                   
                    <!-- <b-form-radio-group
                    v-model="model.status_id"
                    :options="statusOptions"
                    class="mb-3"
                    value-field=""
                    text-field="name"
                    disabled-field="notEnabled"
                    ></b-form-radio-group>
                    <div class="mt-3">Selected: <strong>{{ selected }}</strong></div> -->
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label for="outcome_summary" class="" style="font-size:17px;">KeyddAchievements</label>
                </b-col>
                <b-col sm="9">
                    <vue-editor style="background-color:#F4F4F4;" id="outcome_summary" placeholder="" rows="5" max-rows="5"
                        v-bind:disabled="savingInfo" v-model="model.key_achievements">
                    </vue-editor>
                </b-col>

            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label for="outcome_summary" class="" style="font-size:17px;">Impact</label>
                </b-col>
                <b-col sm="9">
                    <vue-editor style="background-color:#F4F4F4;" id="outcome_summary" placeholder="" rows="5" max-rows="5"
                        v-bind:disabled="savingInfo" v-model="model.impact"></vue-editor>
                </b-col>
            </b-row>
             <b-row class="my-3">
                <b-col sm="3">
                    <label for="outcome_summary" class="" style="font-size:17px;">Key Lessons</label>
                </b-col>
                <b-col sm="9">
                    <vue-editor style="background-color:#F4F4F4;" id="outcome_summary" placeholder="" rows="5" max-rows="5"
                        v-bind:disabled="savingInfo" v-model="model.key_lessons"></vue-editor>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label for="ed_mandate" class="" style="font-size:17px;">Recommendations</label>
                </b-col>
                <b-col sm="9">
                    <vue-editor style="background-color:#F4F4F4;" id="ed_mandate" placeholder="" rows="5" max-rows="5"
                        v-bind:disabled="savingInfo" v-model="model.recommendations"></vue-editor>
                </b-col>
            </b-row>
             <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Name:</label>
                </b-col>
                <b-col sm="9">
                    <b-form-input v-bind:disabled="savingInfo" style="background-color:#F4F4F4; border-radius: unset;" id="outcome_code" v-model="model.submitter_name" :state="outcomeCodeState" required></b-form-input>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Confirmation:</label>
                </b-col>
                <b-col sm="9">
                            <p style="font-size:17px;">
                                I have filled all the information correctly.
                            </p> 
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="3">
                </b-col>
                <b-col sm="9" style="text-align:left;">
                             <label for="agree">
                                 <!--<input id="agree" type="checkbox" value="1" v-model="model.submitted"/> I Confirm-->
                                 <b-form-checkbox
                                    id="agree_reporter"
                                    v-model="model.submitted_reporter"
                                    name="checkbox-1"
                                    value="2"
                                    unchecked-value="1"
                                    >
                                    I Confirm
                                 </b-form-checkbox>  
                            </label>
                            
                </b-col> 
            </b-row>
            <div style="pointer-events: none;">
            <b-row class="my-5">
                <b-col sm="12">
                <h5 style="color:#00A2E4; font-weight:600;">Section B: For UNEP Secretariat/PPD Administrator:</h5>
                </b-col>
            </b-row>
            
            <b-row class="my-1">
                <b-col sm="3">
                    <label class="" style="font-size:17px;">Name:</label>
                </b-col>
                <b-col sm="9">
                    <b-form-input v-bind:disabled="savingInfo" style="background-color:#F4F4F4; border-radius: unset;" id="outcome_code" v-model="model.admin_name" :state="outcomeCodeState"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col sm="3">
                    <label class=" mt-2" style="font-size:17px;">Confirmation:</label>
                </b-col>
                <b-col sm="9">
                            <p style="font-size:17px;">
                                The information provided are satisfactory.
                            </p> 
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="3">
                </b-col>
                <b-col sm="9" style="text-align:left;">
                             <label for="agree">
                                 <!--<input id="agree" type="checkbox" value="1" v-model="model.submitted"/> I Confirm-->
                                 <b-form-checkbox
                                    id="agree_adim"
                                    v-model="model.submitted_admin"
                                    name="checkbox-2"
                                    value="2"
                                    unchecked-value="1"
                                    >
                                    I Confirm
                                 </b-form-checkbox>  
                            </label>
                            
                        </b-col> 
            </b-row>
            </div>
            <b-container>
            <b-row class="my-1 mt-5">
                <b-col sm="8">
                </b-col>
                <b-col sm="2">
                    <div><span v-html="processingMessage"/></div>
                </b-col>
                <b-col sm="2" class="text-right mb-2 align-items-center d-flex justify-content-center" style="background-color:#91C85F; min-height:56px;">
                    <b-button v-bind:disabled="savingInfo" type="submit" size="md" style="background-color:#91C85F; border-radius: unset; border: none; outline:none; font-size:17px; color:#565754; font-weight:600;">{{ saveText }}</b-button>
                </b-col>
            </b-row>
            <b-row class="my-1">
                <b-col sm="10">
                </b-col>
                <b-col v-bind:hidden="showReset" sm="2" class="text-right mb-2 align-items-center d-flex justify-content-center" style="background-color:#565754; min-height:56px;">
                    <b-button  @click="resetForm" v-bind:disabled="savingInfo" type="button" size="md" style="border-radius: unset; border: none; font-size:17px; outline:none; background-color:#565754; border-radius: unset; font-weight:600; color:white;">Reset Form</b-button>
                </b-col>
            </b-row>
            </b-container>
        </form>
    </b-container>
</div>
</template>
<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            Multiselect
        },
        name: 'Addclosure',
        data() {
            return {
                id: 0,
                apiUrl: process.env.VUE_APP_API_PATH,
                max: 400,
                submitted_admin: 0,
                submitted_reporter: 0,
                processingMessage: '',
                outcomeCodeState: null,
                outcomeNameState: null,
                outcomeLinkState: null,
                assemblyCodeState: null,
                statusIdState: null,
                outcomeReporterState: null,
                assemblyIdState: null,
                outcomeTypeState: null,
                powState: null,
                projectState: null,
                sdgState: null,
                indState: null,
                poweaState: null,
                targetState: null,
                savingInfo: false,
                saveText: 'Save Closure',
                assemblyOptions: [],
                powsOptions: [],
                statusOptions: [],
                reasonOptions: [],
                outcomeTypeOptions: [],
                powOptions: [],
                //poweaOptions:[],
                divisionsOptions: [],
                secondaryReporterOptions: [],
                primaryReporterOptions: [],
                isLoadingDivisions: false,
                isLoadingPowea: false,
                isLoadingIndicators : false,
                isLoadingSecondaryReporter: false,
                isLoadingPrimaryReporter: false,
                model: {
                    outcome_id: '',
                    outcome_code: '',
                    outcome_name: '',
                    assembly_id: '',
                    key_achievements: '',
                    key_lessons: '',
                    impact: '',
                    recommendations: '',
                    status_id: '',
                    submitter_name: '',
                    submitted_reporter: '0',
                    admin_name: '',
                    submitted_admin: '0',
                    pows: '',
                    reason_id: '',
                    closure_division: [],
                    closure_secondary_reporter: [],
                    closure_primary_reporter: [],
                },
            }
        },
        computed: {
            showReset() {
                return this.id > 0;
            }
        },
        getShowEditDelete(){
                let isadmin = document.getElementById('loggedInUserIsAdmin').value;
                if(isadmin != '1'){
                    return true;
                }

                return false;
            },
        created() {
             this.id = this.$route.params.id;
        },
        mounted() {
            this.fetchData()
        },
        methods: {
            asyncFindDivisions (query) {
                this.isLoadingDivisions = true;
                let url = this.apiUrl;
                fetch(url + '/getdivisionsoptions?search=' + query)
                    .then(res => res.json())
                    .then(res => {
                        this.divisionsOptions = res;
                        this.isLoadingDivisions = false;
                    })
            },

            asyncFindPrimary (query) {
                this.isLoadingPrimaryReporter = true;
                let url = this.apiUrl;
                fetch(url + '/getreporteroptions?search=' + query)
                    .then(res => res.json())
                    .then(res => {
                        this.primaryReporterOptions = res;
                        this.isLoadingPrimaryReporter = false;
                    })
            },
            asyncFindSecondary (query) {
                this.isLoadingSecondaryReporter = true;
                let url = this.apiUrl;
                fetch(url + '/getreporteroptions?search=' + query)
                    .then(res => res.json())
                    .then(res => {
                        this.secondaryReporterOptions = res;
                        this.isLoadingSecondaryReporter = false;
                    })
            },
            resetForm() {
                this.model.outcome_code = '';
                this.model.outcome_name = '';
                this.model.assembly_id = '';
                this.model.key_achievements = '';
                this.model.key_lessons = '';
                this.model.impact = '';
                this.model.status_id = '';
                this.model.submitter_name = '';
                this.model.submitted_admin = '';
                this.model.admin_name = '';
                this.model.submitted_reporter = '';
                this.model.closure_division = [];
                this.model.pows = '';
                this.model.closure_secondary_reporter = [];
                this.model.closure_primary_reporter = [];
            },
            fetchData() {
                let url = this.apiUrl;
                fetch(url + '/getaddclosuredata?id='+ this.id)
                    .then(res => res.json())
                    .then(res => {
                        this.statusOptions = res["status"];
                        this.reasonOptions = res["reason"];
                        this.assemblyOptions = res["assemblies"];
                        this.powsOptions = res["pows"];
                        this.secondaryReporterOptions = res["secondary_reporter_options"];
                        this.primaryReporterOptions = res["primary_reporter_options"];
                        this.divisionsOptions = res["division_options"];
                        //this.poweaOptions = res["pow_ea_options"];
                        if(res["model"]){
                            this.saveText = "Submit Closure";
                            this.model = res["model"];
                            //this.id = res["model"]['id']
                        }
                    })
            },
            saveOutcome: function () {
                this.savingInfo = true;
                this.processingMessage = '';

                if (!this.$refs.form.checkValidity()) {
                    this.savingInfo = false;
                    return
                }

                this.processingMessage = "<span style='color: orange;'>Saving outcome ...</span>";
                let url = this.apiUrl + '/addclosure/' + this.id;

                fetch(url, {
                    method: 'post',
                    headers: {'Content-Type': 'application/json',
                               'Accept': 'application/json'},
                    body: JSON.stringify(this.model)
                })
                .then((res) => {
                    if (!res.ok) {
                        throw new Error("HTTP status " + res.status);
                    }
                    return res.json();
                })
                .then(res => {
                    this.savingInfo = false;
                    if(res.success){
                        if(this.id == 0) this.resetForm();
                        this.processingMessage = "<span style='color: green;'>Closure has been " + (this.id > 0 ? 'Submitted' : 'saved') + " successfully.</span>";
                        setTimeout(() => {
                            this.processingMessage = '';
                            if(this.id > 0) this.$router.push('/viewoutcome/'+ this.id + window.location.reload());
                        }, 1000);
                    }else{
                        this.processingMessage = "<span style='color: red;'>Error occurred: " + res.message + "</span>";
                    }
                }).catch(error => {
                    this.savingInfo = false;
                    this.processingMessage = "<span style='color: red;'>Error occurred: " + error + "</span>";
                });
            },
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
    .multiselect__tag {
        background-color: rgb(0, 173, 238);
    }
    .emptySelect .multiselect__content li:first-child{
        display: block !important;
    }
    .emptySelect .multiselect__content li:last-child{
        display: none !important;
    }
    .quillWrapper {
        max-width: 860px!important;
    }
    .ql-container{
        height: 78% !important;
    }
    .addclosure{
        margin: auto!important;
    }
    .multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: unset;
    border: 1px solid #e8e8e8;
    background: #F4F4F4!important;
    font-size: 14px;
}
</style>